import { array, number, object } from 'yup';
import { translateAndCastToString } from '../../../../utils';

const realCountRegExp = new RegExp(/^\d{0,4}(\.\d{1,3})?$/);

export const realCountValidation = number()
    .nullable()
    .min(0, translateAndCastToString('Quantity must be greater or equal to 0'))
    .max(
        9999.999,
        () => translateAndCastToString('Must be less than 10 000'),
    )
    .test(
        'decimalPlaces',
        translateAndCastToString('Must have 3 digits after decimal or less and 4 digits before decimal or less'),
        num => num ? realCountRegExp.test(num.toString()) : true,
    )
    .optional();

export const currentinventoryCountValidationSchema = object().shape({
    inventoryCountItems: array()
        .of(object(
            {
                realCount: realCountValidation,
            }
        ).required())
        .min(0)
});
